import {
  getMobileAndDesktopFirstImage,
  getMobileAndDesktopFirstVideo,
} from 'components/PageSections/utils';

import { BenefitsCardsProps } from './BenefitsCards';

export const parserBenefitsCards = (
  section: Queries.ContentfulSection001,
): BenefitsCardsProps => {
  const subsections = section?.subsections as Queries.ContentfulSection001[];

  const subsectionWithBenefitsDescription =
    subsections && subsections.length > 1 ? subsections[0] : null;
  const subsectionWithImageOrVideo =
    subsections && subsections.length > 0 ? subsections[1] : null;

  const sectionImages = getMobileAndDesktopFirstImage(
    subsectionWithImageOrVideo?.images ?? null,
  );
  const sectionVideos = getMobileAndDesktopFirstVideo(
    subsectionWithImageOrVideo?.images ?? null,
  );

  return {
    mobileImage: sectionImages.mobileImage,
    desktopImage: sectionImages.desktopImage,
    mobileVideo: sectionVideos.mobileVideo,
    desktopVideo: sectionVideos.desktopVideo,
    benefitsCardDescription: {
      backgroundColor:
        subsectionWithBenefitsDescription?.metadata?.theme?.backgroundColor ??
        null,
      topTitlePart: {
        text: subsectionWithBenefitsDescription?.metadata?.title,
        color: subsectionWithBenefitsDescription?.metadata?.theme?.primaryColor,
      },
      bottomTitlePart: {
        text: subsectionWithBenefitsDescription?.eyebrow,
        color:
          subsectionWithBenefitsDescription?.metadata?.theme?.secondaryColor,
      },
      bullets: (
        subsectionWithBenefitsDescription?.subsections as Queries.ContentfulSection001[]
      )?.map((subsection) => ({
        title: subsection?.metadata?.title ?? '',
        description: subsection?.metadata?.description?.description ?? '',
        iconName: subsection?.metadata?.context?.iconName ?? null,
        iconColor: subsection?.metadata?.context?.iconColor ?? null,
      })),
    },
  };
};
